import React from 'react';
import PropTypes from 'prop-types';

const RadioButtons = (props) => {
  const handleChange = (e) => {
    props.onChange(e.target.value);
  };

  return (
    
    <div className={ props.horizontal ? 'checkradio-group inline' : 'checkradio-group' }>
      {props.values.map((item, index) => {        
        return (
          <div className="ci-radio" key={index}>
            <input
              id={props.name+`-`+index}
              type="radio"
              name={props.name}
              value={item.value}
              onChange={handleChange}
              checked={props.selectedValue === item.value}
              disabled={props.disabled || item.disabled}
            />
            <label htmlFor={props.name+`-`+index}>{item.label}</label>
          </div>
      );
      })}
    </div>
  );
};

RadioButtons.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  })).isRequired,
  selectedValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  horizontal: PropTypes.bool
};

export default RadioButtons;
